// extracted by mini-css-extract-plugin
export default {"password-generator":"cHLfDwLa4GDpLfXpCC3g","passwordGenerator":"cHLfDwLa4GDpLfXpCC3g"};